export default __webpack_public_path__ + "static/media/Lightning_Special.ba3d5eda.png";